<template>
  <div>
    <NavBar />
    <div id="dashboard-main" class="mt-5">
      <!-- Nombre de logiciels avec un problème (en rouge) -->
      <SimplifiedStatisticsCardSection
        id="software-info1"
        type="critical"
        :isLoading="isLoading"
        :softwareCount="softwaresStatus[2]"
      />
      <SimplifiedStatisticsCardSection
        id="software-info2"
        type="warning"
        :isLoading="isLoading"
        :softwareCount="softwaresStatus[1]"
      />
      <SimplifiedStatisticsCardSection
        id="software-info3"
        type="alive"
        :isLoading="isLoading"
        :softwareCount="softwaresStatus[0]"
      />
      <!-- Liste de serveurs -->
      <div id="server-list1" class="bg-white shadow-sm rounded-lg server-list">
        <ListSoftwaresByServerSection
          v-if="serversToShow"
          :serverId="serversToShow[0].id"
          :serverIp="serversToShow[0].ip"
          :serverName="serversToShow[0].nom"
        ></ListSoftwaresByServerSection>
      </div>
      <!-- Deuxième liste de serveur -->
      <div id="server-list2" class="bg-white shadow-sm rounded-lg server-list">
        <ListSoftwaresByServerSection
          v-if="serversToShow"
          :serverId="serversToShow[1].id"
          :serverIp="serversToShow[1].ip"
          :serverName="serversToShow[1].nom"
        ></ListSoftwaresByServerSection>
      </div>
      <!-- Statistiques avec un tableau -->
      <div id="statistics" class="d-flex">
        <div id="statistic1" class="w-50">
          <ChartSoftwareState
            class="bg-white p-5 shadow-sm mr-2 rounded-lg"
            :title="'components.charts.titleCriticalCases' | i18n"
            :topText="'components.charts.topTextLastMonths' | i18n"
            :subtitle="'components.charts.subtitlePerMonths' | i18n"
            :type="'components.charts.typeBar' | i18n"
            :id="1"
          />
        </div>
        <div id="statistic2" class="w-50">
          <ChartSoftwareState
            class="bg-white p-5 shadow-sm ml-2 rounded-lg"
            :title="'components.charts.titleNotifications' | i18n"
            :topText="'components.charts.topTextLastMonths' | i18n"
            :subtitle="'components.charts.subtitlePerMonths' | i18n"
            :type="'components.charts.typeBar' | i18n"
            :id="2"
          />
        </div>
      </div>
      <div
        id="full-software-list"
        class="bg-white p-4 shadow-sm rounded-lg w-100"
      >
        <ListSoftwaresByClientSection
          class="p-4"
          :clientId="+this.$user.get().client_id"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
  ListSoftwaresByServerSection,
  ListSoftwaresByClientSection
} from "@/sections";

import {
  ChartSoftwareState,
  NavBar,
  SimplifiedStatisticsCardSection
} from "@/components";
/**
 * @description Vue du tableau de bord. Contient la plupart des informations
 * utiles à voir rapidement
 * @author Benjamin Caron
 * @author Félix Bordage
 * @author Samuel Colassin
 * @vue-data {Boolean} isLoading - Si la page est en train de charger
 * @vue-data {Array} softwareInfoClasses - Classes que devront porter
 * chacune des cartes d'information rapide. Nécessaire pour ajuster leur couleur
 * @vue-data {Array} serversToShow - Les serveurs problématiques à afficher
 * @vue-data {Array} softwaresStatus - Le nombre de logiciels dans chaque état
 */
export default {
  components: {
    SimplifiedStatisticsCardSection,
    ChartSoftwareState,
    ListSoftwaresByServerSection,
    ListSoftwaresByClientSection,
    NavBar
  },
  data() {
    return {
      isLoading: true,
      softwareInfoClasses: [
        "bg-white p-4 shadow-sm rounded-lg",
        "bg-white p-4 shadow-sm rounded-lg",
        "bg-white p-4 shadow-sm rounded-lg"
      ],
      serversToShow: null,
      softwaresStatus: [0, 0, 0]
    };
  },
  /**
   * @description Permet de charger toutes les informations nécessaires
   */
  async beforeMount() {
    this.isLoading = true;
    await this.getDashboardData();
    this.isLoading = false;
    setInterval(this.refresh, 15000);
  },
  methods: {
    /**
     * @description Rafraichit les données
     */
    async refresh() {
      this.isLoading = true;
      await this.getDashboardData();
      this.isLoading = false;
    },
    /**
     * @description Met à jour la couleur de l'une des cartes d'information rapide.
     * @param {Object} e Détails de l'événement. Contient l'information
     * nécessaire pour mettre à jour la bonne carte, avec la bonne couleur
     */
    setSoftwareInfoBG(e) {
      this.$set(
        this.softwareInfoClasses,
        e.softwareInfoId,
        `${e.backgroundColor} p-4 shadow-sm rounded-lg`
      );
    },
    /**
     * @description Permet d'obtenir les informations du tableau de bord
     */
    async getDashboardData() {
      await this.$api
        .getServersByClient(this.$user.get().client_id)
        .then(res => {
          this.serversToShow = res.data.data.slice(0, 2);
        });
      await this.$api
        .getClientSoftwareStates(this.$user.get().client_id)
        .then(res => {
          this.softwaresStatus = res.data;
        });
    }
  }
};
</script>
<style scoped lang="scss">
#software-info1 {
  grid-area: software-info1;
}

#software-info2 {
  grid-area: software-info2;
}

#software-info3 {
  grid-area: software-info3;
}

.server-list {
  padding: 8%;
}

#server-list1 {
  grid-area: server-list1;
}

#server-list2 {
  grid-area: server-list2;
}

#statistics {
  grid-area: statistics;
}

#arrow1 {
  grid-area: arrow1;
}

#arrow2 {
  grid-area: arrow2;
}

#full-software-list {
  grid-area: full-software-list;
}

#dashboard-main {
  width: 1366px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 250px 1fr 1fr;
  grid-template-rows: 220px 220px 220px auto auto;
  grid-template-areas:
    "software-info1 server-list1 server-list2 ."
    "software-info2 server-list1 server-list2 arrow1"
    "software-info3 server-list1 server-list2 ."
    "statistics statistics statistics ."
    "statistics statistics statistics arrow2"
    "statistics statistics statistics ."
    "full-software-list full-software-list full-software-list .";
  grid-gap: map-get($map: $spacers, $key: 4);
}

@media screen and (max-width: 1025px) {
  #dashboard-main {
    width: 95%;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas:
      "software-info1 software-info2 software-info3 ."
      "server-list1 server-list1 server-list1 ."
      "server-list1 server-list1 server-list1 arrow1"
      "server-list1 server-list1 server-list1 ."
      "statistics statistics statistics ."
      "statistics statistics statistics arrow2"
      "statistics statistics statistics ."
      "full-software-list full-software-list full-software-list .";
    grid-gap: map-get($map: $spacers, $key: 4);
  }
  #statistic1 {
    width: 200% !important;
    margin-right: 0 !important;
  }
  #statistic2 {
    display: none;
  }
  #server-list2 {
    display: none;
  }
}

@media screen and (max-width: 414px) {
  #dashboard-main {
    min-width: 100% !important;
    grid-template-columns: 100% 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas:
      "software-info1"
      "software-info2"
      "software-info3"
      "server-list1"
      "statistics"
      "full-software-list";
    grid-gap: map-get($map: $spacers, $key: 4);
  }

  #statistic1 {
    width: 200% !important;
    margin-right: 0 !important;
  }

  #statistic2 {
    display: none;
  }

  #server-list2 {
    display: none;
  }

  #arrow1 {
    display: none;
  }

  #arrow2 {
    display: none;
  }
}
</style>
